import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import { enqueueSnackbar } from './snackbar';
import * as ENVIRONMENT from '../../shared/config/config';
import { listWells } from './wells';
import { modifyMetricData } from '../../utils/getMetrics';
import { UNIT_SYSTEM } from '../../shared/config/hydraulics_constants';
import { VERSION } from '../../shared/config/version';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const listPWD = (wellId, closeDialog) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .post('wells/entity/pwd/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: pwdData, units } = data;
      const modifiedPWDData = modifyMetricData(pwdData, units, currentUnit);
      dispatch({
        type: REDUX_ACTIONS.WELLS_PWD_LIST_SUCCESS,
        payload: {
          ...data,
          data: modifiedPWDData.sort((a, b) => a.MD - b.MD),
          paginatedElements: modifiedPWDData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      if (error?.status === 403) {
        closeDialog?.();
      }
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.WELLS_PWD_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const addNewPWDRow = () => (dispatch) => {
  const { wellsPWD } = store.getState();
  const newPWD = [...wellsPWD.data];
  const existUnit = { ...wellsPWD.units };
  const nextId = newPWD.length - 1;
  const newRow = {
    md: '',
    p: '',
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true
  };
  newPWD.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_SUCCESS,
    payload: {
      data: newPWD,
      units: existUnit,
      paginatedElements: newPWD.length,
    },
  });
};

export const createPWD = (body, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_LOADING,
  });
  delete body._id;
  const input = {
    query: {
      wellsInfoId: wellId
    },
    input: {
      ...body,
    }
  };
  return fetchAPI
    .post('wells/entity/pwd/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'PWD Details Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listPWD(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listPWD(wellId));
    });
};

export const updatePWD = (body, wellId, rowId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_LOADING,
  });
  const input = {
    query: {
      _id: rowId,
      wellsInfoId: wellId
    },
    input: {
      ...body
    }
  };
  return fetchAPI
    .put('wells/entity/pwd', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'PWD Details Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listPWD(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listPWD(wellId));
    });
};

export const deletePWDRow = (deletePWDId, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_LOADING,
  });
  const body = {
    query: {
      _id: deletePWDId,
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .deleteAction('wells/entity/pwd', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'PWD Details Deleted Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listPWD(wellId));
      dispatch(listWells());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listPWD(wellId));
    });
};

export const updatePWDDetails = (data) => (dispatch) => {
  const { wellsPWD } = store.getState();
  const currentPWD = [...wellsPWD.data];
  const index = currentPWD.findIndex(pwd => pwd._id === data._id);
  currentPWD[index] = data;
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_SUCCESS,
    payload: {
      data: currentPWD.sort((a, b) => a.md - b.md),
      paginatedElements: currentPWD.length,
    },
  });
};

export const importWellsPWDCSVFIle = (file, wellId, setIsLoading, handleUploadSuccess) => async (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.WELLS_PWD_LIST_LOADING,
  });
  const formData = new FormData();
  const { currentUser } = store.getState();
  const ipDetails = {
    ip: currentUser?.ip,
  };
  const BASE_URL = ENVIRONMENT.API_URL;
  formData.append('file', file);
  const payload = {
    query: {
      wellsInfoId: wellId
    },
    user: {
      type: currentUser.type,
      companyId: currentUser.companyId,
      userId: currentUser.userId,
      unitSystem: currentUser?.preferences?.unitSystem || UNIT_SYSTEM.US,
      ...(ipDetails?.ip && { ...ipDetails }),
      version: VERSION
    },
  };
  formData.append('payload', JSON.stringify(payload));
  setIsLoading(true);
  try {
    const response = await fetch(`${BASE_URL}wells/entity/pwd/import`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });
    if (response.status !== 200) {
      const errorData = await response.json();
      const errorMessage = errorData.message;
      throw new Error(errorMessage);
    }
    dispatch(
      enqueueSnackbar(
        'CSV Imported Successfully',
        'success',
        new Date().getTime() + Math.random()
      )
    );
    setIsLoading(false);
    handleUploadSuccess();
    dispatch(listPWD(wellId));
    dispatch(listWells());
  } catch (error) {
    let errorMessage = '';

    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error instanceof Error) {
      errorMessage = error.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else {
      errorMessage = 'An unknown error occurred';
    }

    const extractedMessage = errorMessage.split(' at importPwdDataFromCSV')[0].trim();

    dispatch(
      enqueueSnackbar(
        extractedMessage,
        'error',
        new Date().getTime() + Math.random()
      )
    );
    setIsLoading(false);
    dispatch(listPWD(wellId));
  }
};
